var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconCameraOn(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.83317 8.16671H17.4998C18.7885 8.16671 19.8332 9.21138 19.8332 10.5L19.8332 11.9269V16.0732L19.8332 17.5C19.8332 18.7887 18.7885 19.8334 17.4998 19.8334H5.83317C4.54451 19.8334 3.49984 18.7887 3.49984 17.5V10.5C3.49984 9.21138 4.54451 8.16671 5.83317 8.16671ZM22.1618 17.7122C22.0509 20.191 20.0061 22.1667 17.4998 22.1667H5.83317C3.25584 22.1667 1.1665 20.0774 1.1665 17.5V10.5C1.1665 7.92271 3.25584 5.83337 5.83317 5.83337H17.4998C20.0061 5.83337 22.0509 7.80905 22.1618 10.2879L26.8332 7.00004V21L22.1618 17.7122ZM22.1665 14.8622L24.4998 16.5049V11.4964L22.1665 13.1379V14.8622Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCameraOn);
export default __webpack_public_path__ + "static/media/icon-camera_on.7160258dc0c3e4914a642dd6f9429a11.svg";
export { ForwardRef as ReactComponent };